import { VALIDATE_CODES } from './codes';
export var required = function (errorText) {
    return function (value, values, texts) {
        var val = typeof value === 'string' ? value.replace(/\s+/g, '') : value;
        if (Array.isArray(val)) {
            return val.length ? '' : errorText || texts[VALIDATE_CODES.required];
        }
        if (val || val === 0 || val === false) {
            return '';
        }
        return errorText || texts[VALIDATE_CODES.required];
    };
};
//# sourceMappingURL=required.js.map